import { Avatar } from '@mui/material';
import { CSSProperties } from 'react';
import { usePlaceholderStyles } from './placeholders.styles';

export function AvatarPlaceHolder({ diameter, style }: { diameter?: number; style?: CSSProperties }) {
  const classes = usePlaceholderStyles({ avatarDiameter: diameter });
  return (
    <Avatar style={style} className={[classes.avatar, classes.pulse].join(' ')}>
      {' '}
      {/* Single space char to prevent avatar falling back to default icon */}
    </Avatar>
  );
}
